var shvenergy = shvenergy || {};
shvenergy.search = (function ($) {
    return {
    };
})(jQuery);

shvenergy.search.dealer = (function ($) {
    "use strict";
    var dealerType = $('input[name=toggle]:checked').val();
    var constBounceKey = "dealerSearch";
    var detailsWrapper = $(".map-dealerdetails");
    var currentDealer;

    function autocomplete(searchTerm, results, cb, appendTo) {
        if (getFromLastSearch(searchTerm, results, cb, appendTo)) {
            return;
        }

        $.ajax({
            type: "POST",
            url: "/api/dealer/searchbyname",
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            data: JSON.stringify({
                DealerName: searchTerm,
                DealerType: dealerType,
                isMobile: window.matchMedia('(max-width: 640px)').matches,
            }),
            success: function (data) {
                results.dealers = data.dealers;

                cb(results.dealers, "address", searchTerm, appendTo, "Dealer_16x16");

                shvenergy.tracking.trackRawEventData({
                    'event': 'clickDFSearch',
                    'searchType': dealerType,
                    'query': searchTerm
                });
            },
            error: function (jqXHR, textStatus) {
                console.warn(textStatus);
            }
        });
    }

    function getFromLastSearch(searchTerm, results, cb, appendTo) {
        if (!results.lastTerm || !results.lastTerm.startsWith(searchTerm) || !results.dealers || results.dealers.results > 5)
            return;

        results.dealers = $.grep(results.dealers, function (element) {
            return element.description.indexOf(searchTerm) !== -1;
        });
        cb(results.dealers, "address", searchTerm, appendTo);
        return;
    }

    function searchByLocation(bounds, zoomLevel) {

        var currentLocation = shvenergy.maps.getDefaultMarkerLocation();

        //console.log("bounds: ", bounds);
        //console.log("zoomLevel: ", zoomLevel);
        //console.log("currentLocation: ", currentLocation);
        var start_time;
        shvenergy.bounce.runNamed(constBounceKey,
            function () {
                // TODO: Extend this with filters
                $.ajax({
                    type: "POST",
                    url: "/api/dealer/searchbyarea",
                    contentType: "application/json; charset=utf-8",
                    dataType: "json",
                    beforeSend: function () {
                        start_time = new Date().getTime();
                    },
                    data: JSON.stringify({
                        northEast: bounds.getNorthEast(),
                        southWest: bounds.getSouthWest(),
                        zoomLevel: zoomLevel,
                        location: currentLocation,
                        dealerType: dealerType,
                        hasSpecialOrderAvailable: false,
                        isOpenNow: false,
                        dealerStoreTypes: getDealerStoreTypes(),
                        dealerBrandNames: getDealerBrandNames(),
                        tags: getDealerTags(),
                        filters: getDealerFilterGroups(),
                        isDeliveryAvailable: getFilter("dealerDeliveryAvailableFilter"),
                        isBio: getFilter("dealerBioFilter"),
                        isTruckLpg: getFilter("dealerTruckLpgFilter"),
                        isPreferredPartner: getFilter("dealerPreferredPartnerFilter") || getFilter("dealerPromotedPreferredPartnerFilter"),
                        sortBy: shvenergy.maps.locationMarker.visible ? "Distance" : "Name",
                        isMobile: window.matchMedia('(max-width: 640px)').matches,

                    }),
                    success: function (data) {
                        var request_time = new Date().getTime() - start_time;
                        console.log("searchbyarea request process time: " + request_time);
                        shvenergy.maps.createDealerMarkers(data);
                    },
                    error: function (jqXHR, textStatus) {
                        console.warn(textStatus);
                    }
                });
            }, 40);
    }

    function getFilter(filterName) {
        var self = $("#" + dealerType + "-" + filterName);

        if (self && self.length) {
            return self.prop("checked");
        } else {
            return false;
        }
    }

    function getDealerFilterGroups() {
        var filters = [];
        $("input[data-type=" + dealerType + "-Filter]:checked").each(function () {
            var self = $(this);
            var id = self.val();
            filters.push(id);
        });

        $("input[data-filter=" + dealerType + "-dealerBrandFilter]:checked").each(function () {
            var self = $(this);
            var id = self.val();
            filters.push(id);
        });

        return filters;
    }

    function getDealerTags() {
        var tags = [];
        $("input[data-type=" + dealerType + "-Tag]:checked").each(function () {
            var self = $(this);
            var id = self.val();
            tags.push(id);
        });
        return tags;
    }

    function getDealerStoreTypes() {
        var storeTypesArray = [];

        var pane = $("[data-paneid=" + dealerType + "-dealerStoreTypeFilter]");

        pane.find("input[type=checkbox]").each(function () {
            var self = $(this);
            var id = self.val();

            if (self.prop("checked")) {
                storeTypesArray.push(id);
            }
        });

        //console.log(storeTypesArray);

        return storeTypesArray;
    }

    function getDealerBrandNames() {
        var dealerBrandNamesArray = [];

        var pane = $("[data-paneid=" + dealerType + "-dealerBrandNameFilter]");

        pane.find("input[type=checkbox]").each(function () {
            var self = $(this);
            var id = self.val();

            if (self.prop("checked")) {
                dealerBrandNamesArray.push(id);
            }
        });

        var paneBrandFilter = $("[data-type=" + dealerType + "-DealerBrandFilter]");

        $(paneBrandFilter).each(function () {
            var self = $(this);
            var ids = self.val().split("|");


            if (self.prop("checked")) {

                ids.forEach(function (id) {
                    dealerBrandNamesArray.push(id);
                });


            }
        });

        const unique = (value, index, self) => {
            return self.indexOf(value) === index;
        };

        const uniqueDealerBrandNamesArray = dealerBrandNamesArray.filter(unique);

        return uniqueDealerBrandNamesArray;
    }

    function getDetails(id) {
        console.log("getDetails...")

        //at this point we need to be sure that markers are not clusters
        var checkMarkersInterval = setInterval(function () {
            var checMarkerStatus = shvenergy.maps.areMarkersCreatedAndNotClusters()

            if (checMarkerStatus) {
                clearInterval(checkMarkersInterval);
                shvenergy.tracking.trackEvent("Dealerfinder", "Dealer clicked", id);

                //$("#map-sidebar").removeClass("is-invisible");
                currentDealer = id;
                var url = "";

                var defaultmarkerLocation = shvenergy.maps.getDefaultMarkerLocation();
                var dealerLocation = shvenergy.maps.getMarkerById(currentDealer);
                var lat, lng;

                // Create shareable URL for a specific dealer and add to browser history
                var searchUrl = new URL(window.location);
                var oldDealerId = searchUrl.searchParams.get("dealerId");

                if (oldDealerId !== currentDealer) {
                    searchUrl.searchParams.set("dealerId", currentDealer);
                    searchUrl.searchParams.set("view", "details");
                }

                //If location
                if (defaultmarkerLocation != null) {
                    //console.log(defaultmarkerLocation);
                    url = window.location.pathname +
                        "/" +
                        id +
                        "/details?Latitude=" +
                        defaultmarkerLocation.lat() +
                        "&Longitude=" +
                        defaultmarkerLocation.lng();
                } else if (dealerLocation) {
                    //console.log(dealerLocation);
                    lat = dealerLocation.position.lat();
                    lng = dealerLocation.position.lng();

                    url = window.location.pathname +
                        "/" +
                        id +
                        "/details?Latitude=" +
                        lat +
                        "&Longitude=" +
                        lng;
                } else {
                    getDetails(id)
                }

                // "Sharable URL"-continued to also allow lat/lng
                if (oldDealerId !== currentDealer) {
                    if (!lat || !lng) {
                        lat = dealerLocation.position.lat();
                        lng = dealerLocation.position.lng();
                    }

                    searchUrl.searchParams.set("lat", lat);
                    searchUrl.searchParams.set("lng", lng);

                    window.history.pushState({}, '', searchUrl);
                }

                detailsWrapper.empty();
                //var startTime = new Date().getTime();

                detailsWrapper.load(url + " #searchDetails", function () {

                    $("#searchDetails").hide().fadeIn(600);
                    detailsWrapper.addClass('isActive');
                    //getOpeningHours();
                    hideLocationAlert();
                    if (defaultmarkerLocation)
                        setGetDirectionsButtons(defaultmarkerLocation);
                    //console.log("detailsWrapper.load() time taken : " + new Date(new Date().getTime()));
                    //var request_time = new Date().getTime() - startTime;
                    //console.log("Time Taken for detailsWrapper.load : " + request_time);
                });

                clearInterval(checkMarkersInterval);

            }
        }, 200);
    }

    function setGetDirectionsButtons(location) {
        var loc = location.lat() + "," + location.lng();
        var getDirectionButtons = $(".get-directions");
        getDirectionButtons.each(function () {

            var currentHref = $(this).attr("href");
            var replacedHref = currentHref.replace("dir//", 'dir/' + loc + '/');

            $(this).attr("href", replacedHref);

        });
        console.log("setGetDirectionsButtons() time taken:" + new Date(new Date().getTime()));
    }

    function getType() {
        return dealerType;
    }

    function setType(val) {
        dealerType = val;
    }

    function setUseDistance(val) {
        useDistance = val;
    }

    function openCampaignBanner() {

        $(document).on("click", "#campaign-arrow", function () {
            console.log('du rammer knappen');
            $(this).toggleClass("search__details__campaign__arrow--closed")
            $(this).next(".search__details__campaign__list").slideToggle();
        });
    }

    function hideLocationAlert() {
        navigator.permissions.query({ name: "geolocation" }).then((result) => {
            if (result.state === "granted") {
                $(".location-reminder").css({ "display": "none" });
            } else {
                $(document).on("click", ".location-reminder__close", function () {
                    $(".location-reminder").css({ "display": "none" });
                });
            }
        });
    }

    openCampaignBanner();

    return {
        autocomplete: autocomplete,
        searchByLocation: searchByLocation,
        getType: getType,
        setType: setType,
        setUseDistance: setUseDistance,
        getDetails: getDetails
    };



})(jQuery);